// extracted by mini-css-extract-plugin
export default {"container":"background_container__BTX4z","background":"background_background__-pZeR"};